import dayjs, { Dayjs } from "dayjs";
import { useSelector } from "react-redux";

import { RootState } from "../../store/store";
import { getMostRecentCompletedSunday } from "../../utils/helpers";
import DateRangeModal from "../Common/Dialogs/DateRangeModal";

interface Props {
  open: boolean;
  onClose: () => void;
  onGenerate: (startDate: Dayjs, endDate: Dayjs | null) => void;
  isSubmitting?: boolean;
  errorMessage?: string | null;
}

export default function StatementOfEntitlementModal({ open, onClose, onGenerate, isSubmitting, errorMessage }: Props) {
  // Child Care Subsidy submissions aren't confirmed by the government system until after the
  // week they cover has fully elapsed, so the statement can't cover any date past the most
  // recently completed Sunday.
  const maxEndDate = getMostRecentCompletedSunday();

  const modalTitle = useSelector((state: RootState) => state.appConfigs.soeModalTitle);
  const modalDescription = useSelector((state: RootState) => state.appConfigs.soeModalDescription);

  return (
    <DateRangeModal
      open={open}
      onClose={onClose}
      title={modalTitle}
      description={modalDescription}
      primaryLabel="Generate"
      secondaryLabel="Cancel"
      onConfirm={onGenerate}
      isSubmitting={isSubmitting}
      errorMessage={errorMessage}
      defaultStartDate={dayjs().subtract(2, "week")}
      defaultEndDate={maxEndDate}
      maxEndDate={maxEndDate}
      endDateMaxDateMessage="End date cannot be later than the most recent completed Sunday, as Child Care Subsidy submissions for later dates are not yet confirmed"
      maxRangeMonths={6}
    />
  );
}
